import Vue from 'vue'
import App from './App.vue'
import router from './router'

import firebase from 'firebase/app'
// eslint-disable-next-line
import auth from 'firebase/auth'

Vue.config.productionTip = false

Vue.filter('formatTime', date => {
  // const formatted = date.toDateString()
  return date
})

Vue.filter('truncate', str => {
  const https = /https:\/\//
  const http = /http:\/\//
  const www = /www\./
  let stripped = ''
  if (http.test(str)) {
    stripped = str.replace('http://', '')
  }
  if (https.test(str)) {
    stripped = str.replace('https://', '')
  }
  if (www.test(stripped)) {
    stripped = stripped.replace('www.', '')
  }

  return stripped
    .split('')
    .slice(0, 20)
    .join('') // + '...'
})

let app = null

/*  
        init firebase auth before app
 */
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
